export function getGlobalQuery() {
  return {
    populate: {
      navbar: {
        populate: {
          logo: { populate: '*' },
          dropdownImage: { populate: '*' },
          button: { populate: '*' },
          mainNavigation: {
            populate: {
              dropDownLinks: {
                populate: {
                  subdropdown: { populate: '*' },
                }
              }
            }
          },
        },
      },
      footer: {
        populate: {
          logos: { populate: '*' },
          socialLinks: { populate: '*' },
          footerColumn: { populate: '*' },
          legalLinks: { populate: '*' },
          accessibilityBadge: { populate: '*' },
        },
      },
    },
  };
}
